<div id="mainDiv" style="
    background: linear-gradient(#F7FAFD, #F7FAFD, #B5D2EC, #B5D2EC) no-repeat;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100vh;
  ">

    <div class="example-full-width">

        <div style="float:left;">
            <img src="assets/Aether_Logo.png" style="margin-left:1rem; height:80px; width:auto;" alt="Aether Logo" />
        </div>

        <form class="formview" [formGroup]="resetPassForm" (ngSubmit)="onConfirm()">

            <div style="
          padding:10%;
          background:white;
          box-shadow: 0 10px 16px rgba(0,0,0,0.2),
                      0 6px 20px rgba(0,0,0,0.19);
        " class="text-center">

                <div class="aeLebel">
                    Welcome {{ userName }}
                </div>

                <div class="example-full-width mt-4">
                    <div class="login-text form-group column aeLebel">

                        <label class="suffix_star">New Password</label>

                        <input class="form-control" [type]="show ? 'text' : 'password'" autocomplete="new-password"
                            placeholder="New Password" formControlName="newPassword" id="newPassword" maxlength="100"
                            required />

                        <span id="eye" class="showpassword" (click)="showPassword()">
                            <i [class]="passwordState" style="color:black;">
                            </i>
                        </span>

                    </div>
                </div>

                <div class="row">
                    <div class="login-text form-group column aeLebel">

                        <label class="suffix_star">
                            Confirm Password
                        </label>

                        <input class="form-control" type="password" autocomplete="password"
                            placeholder="Confirm Password" formControlName="confirmPassword" id="confirmPassword"
                            maxlength="100" required />

                        @if (
                        confirmed &&
                        f.confirmPassword.value &&
                        f.newPassword.value !== f.confirmPassword.value
                        ) {
                        <div class="errorfont errorspacing text-danger">
                            Password not matching
                        </div>
                        }

                    </div>
                </div>

                <div class="mt-4">
                    <button class="btn aeLabel" type="submit" style="background-color:skyblue;">
                        Confirm
                    </button>
                </div>

            </div>
        </form>

    </div>
</div>